export default __webpack_public_path__ + "assets/underlined.ac89337f.svg";